import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import axios from 'axios';
import useJWT from '../utils/useJWT';

const loginUrl = process.env.REACT_APP_DASHBOARD_LOGIN_URL;

const CognitoAuth = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const history = useHistory();
  const [jwt, setJWT] = useJWT();

  useEffect(() => {
    const checkAuth = async () => {
      const nonce = new URLSearchParams(location.search).get('nonce');

      if (jwt) {
        setIsAuthenticated(true);
        setIsLoading(false);
        return;
      }

      if (nonce) {
        try {
          const response = await axios.post('/api/auth/exchange-nonce', { nonce });
          const { accessToken: newAccessToken } = response.data;

          setJWT(newAccessToken);
          setIsAuthenticated(true);

          // Remove the ?nonce from URL
          history.replace(location.pathname);
        } catch (error) {
          console.error('Failed to exchange nonce for token:', error);
          history.push(loginUrl);
        }
      } else {
        history.push(loginUrl);
      }

      setIsLoading(false);
    };

    checkAuth();
  }, [location, history, jwt, setJWT]);

  if (isLoading) {
    return null;
  }

  return isAuthenticated ? children : null;
};

export default CognitoAuth;